import {
  MessageBar,
} from '@fluentui/react';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { isDarkThemeSelector, getCorrelationId } from '../../../web-legacy/packages/app/selectors/contactUsSelector';
import { StyledText } from '../../common/components/StyledText';
import { SAMessageBoxContactSupportCardStyle } from '../styles/selfHelpStyles';
import { getString } from '../../utils/stringLoader';
import { commonClassNames } from '../../../web-legacy/packages/contactUs/styles/commonStyles';
import { IContactUsCurrentTheme } from '../../../web-legacy/packages/contactUs/styles/theme.model';

export interface ISAEndOfLifeContactSupportCardProps {
  theme?: IContactUsCurrentTheme;
}

const SAEndOfLifeContactSupportCardBase = (props: ISAEndOfLifeContactSupportCardProps): JSX.Element => {

  const isDarkTheme = useSelector(isDarkThemeSelector);
  const [isVisible, setVisibility] = React.useState(true);
  const messageBarStyles = SAMessageBoxContactSupportCardStyle(isDarkTheme, props.theme);

  if (!isVisible) {
    return null;
  }

  return (
    <MessageBar
      className={commonClassNames.WUContactSupportflag}
      theme={props.theme}
      messageBarIconProps={{ iconName: 'StatusErrorFull' }}
      dismissButtonAriaLabel="Close"
      styles={messageBarStyles}
    >
      <StyledText>{getString('GetCurrentAfterContactSupportContent')}</StyledText>
    </MessageBar>
  );
};
export const SAEndOfLifeContactSupportCard: React.FunctionComponent<ISAEndOfLifeContactSupportCardProps> = SAEndOfLifeContactSupportCardBase;


